import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { CategoryTree } from '@/helpers/constants/CategoryTree';
/**
 * App category tree builder
 * @author Jan Canicon <jan@gorated.ph>
 * @since Version {x.x.x}
 */
let CategoryTreeMixin = class CategoryTreeMixin extends Vue {
    baseCategories() {
        return Object.keys(CategoryTree)
            .map((category) => {
            const newobj = {
                [category]: {
                    primaryOption: false,
                    secondaryOptions: [],
                },
            };
            return newobj;
        })
            .reduce((a, v) => ({
            ...a,
            ...v,
        }), {});
    }
    buildCategoryTree(categoryTree) {
        const assembledTree = this.baseCategories();
        categoryTree.forEach((categoryGroup) => {
            const category = assembledTree[categoryGroup.primaryCategory];
            category.primaryOption = true;
            category.secondaryOptions = [...categoryGroup.secondaryCategories];
        });
        return assembledTree;
    }
    extractPrimaryCategories(categoryTree) {
        return Object.keys(categoryTree).filter((key) => categoryTree[key].primaryOption);
    }
    extractSecondaryCategories(categoryTree) {
        return Object.keys(categoryTree)
            .map((key) => categoryTree[key].secondaryOptions)
            .flat();
    }
};
CategoryTreeMixin = __decorate([
    Component
], CategoryTreeMixin);
export default CategoryTreeMixin;
